import React from 'react';
import { withAuth } from '../models/functions/with-auth';
import { Layout } from '../blocks/web/layout/layout';
import { createWebServerSideProps } from '../models/functions/create-web-server-side-props';
import { IntroCompoundInterest } from '../blocks/web/compound-interest/intro/intro-compound-interest';
import { CompoundInterest } from '../blocks/web/compound-interest/compound-interest';

const CompoundInterestPage: React.FC = () => {
    return (
        <Layout introAppearance="subpage" intro={<IntroCompoundInterest />}>
            <CompoundInterest />
        </Layout>
    );
};

export const getServerSideProps = createWebServerSideProps();

export default withAuth(CompoundInterestPage, false);
